var map = {
	"./aia.svg": 1400,
	"./ant.svg": 1401,
	"./aus.svg": 1402,
	"./bah.svg": 1403,
	"./ban.svg": 1404,
	"./bar.svg": 1405,
	"./ber.svg": 1406,
	"./biz.svg": 1407,
	"./bot.svg": 1408,
	"./bru.svg": 1409,
	"./can.svg": 1410,
	"./cay.svg": 1411,
	"./cmr.svg": 1412,
	"./cok.svg": 1413,
	"./cyp.svg": 1414,
	"./dma.svg": 1415,
	"./eng.svg": 1416,
	"./fij.svg": 1417,
	"./flk.svg": 1418,
	"./gab.svg": 1419,
	"./gam.svg": 1420,
	"./ggy.svg": 1421,
	"./gha.svg": 1422,
	"./gib.svg": 1423,
	"./grn.svg": 1424,
	"./guy.svg": 1425,
	"./ind.svg": 1426,
	"./iom.svg": 1427,
	"./ivb.svg": 1428,
	"./jam.svg": 1429,
	"./jey.svg": 1430,
	"./ken.svg": 1431,
	"./kir.svg": 1432,
	"./lca.svg": 1433,
	"./les.svg": 1434,
	"./manifest.json": 788,
	"./mas.svg": 1435,
	"./maw.svg": 1436,
	"./mdv.svg": 1437,
	"./mlt.svg": 1438,
	"./moz.svg": 1439,
	"./mri.svg": 1440,
	"./msr.svg": 1441,
	"./nam.svg": 1442,
	"./nfk.svg": 1443,
	"./ngr.svg": 1444,
	"./nir.svg": 1445,
	"./niu.svg": 1446,
	"./nru.svg": 1447,
	"./nzl.svg": 1448,
	"./pak.svg": 1449,
	"./png.svg": 1450,
	"./rsa.svg": 1451,
	"./rwa.svg": 1452,
	"./sam.svg": 1453,
	"./sco.svg": 1454,
	"./sey.svg": 1455,
	"./sgp.svg": 1456,
	"./shn.svg": 1457,
	"./skn.svg": 1458,
	"./sle.svg": 1459,
	"./sol.svg": 1460,
	"./sri.svg": 1461,
	"./svg-country.svg": 1462,
	"./swz.svg": 1463,
	"./tan.svg": 1464,
	"./tca.svg": 1465,
	"./tga.svg": 1466,
	"./tog.svg": 1467,
	"./tto.svg": 1468,
	"./tuv.svg": 1469,
	"./uga.svg": 1470,
	"./van.svg": 1471,
	"./wal.svg": 1472,
	"./zam.svg": 1473
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1399;